import type { Recipe } from "@/helpers/types";
import QuizProductCard from "./QuizProductCard";
import { treatDescriptionFor } from "./productCopy";

type Props = {
    recipe: Recipe;
    count: number;
    onIncrement: () => void;
    onDecrement: () => void;
};

export default function TreatCard({ recipe, count, onIncrement, onDecrement }: Props) {
    const imageSrc = Array.isArray(recipe.image) ? recipe.image[0] : recipe.image;

    return (
        <QuizProductCard
            image={imageSrc}
            title={recipe.title}
            subtitle={`£${Number(recipe.price).toFixed(2)}`}
            description={(recipe as any).description ?? treatDescriptionFor(recipe.title)}
            count={count}
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            accentSeed={(recipe as any).variantId ?? recipe.title}
        />
    );
}
